import BaseComponent from '@/js/core/BaseComponent'
import DOMRenderer from '@/js/hooks/renderer'
import Events from '@/js/core/EventDispatcher'
import gsap from 'gsap'
import $ from 'jquery'

/***
 * we suppose to have data printed in page
 */
export default class NetworkFilters extends BaseComponent {
  // https://www.npmjs.com/package/yuzu
  // https://mipa2021.wearetesting.it/wp-json/wp/v2/_cty_network?_cta_location=1452

  static root = '[data-network-filters]';

  state = { 
    loading: false,
    items: []
  };

  actions = {
    loading(value) {
      this.$el.setAttribute('data-is-loading', value);
    },
    items(data) {
      let cardsContent = '';
      data.forEach((el) => {
        cardsContent += this.createCard(el.title.rendered, el.acf.city, el.acf.indirizzo, el.acf.email, el.acf.telefono)
      })
      document.querySelector('[data-network-cards]').innerHTML = cardsContent;
      setTimeout(() => {
        document.querySelectorAll('.network-card').forEach(el => {
          el.style.opacity = 1
        });
      },500)
    }
  };

  createCard(title, city, address, email, tel) {
    return `<div class="network-card">
              <div class="network-card__wrapper">
                <h5 class="vw mt-0">
                  <span>${title}</span>
                </h5>
                <p class="vw location"><span>${city}<br>${address}</span></p>
                <p class="vw contacts"><span>Email: <a href="mailto:${email}">${email}</a><br>Tel: ${tel}</span></p>
              </div>
            </div>`;
  }

  selectOnChange(value, arr, target, clearArr = []) {
    document.querySelector(`[name="network-filters-${value}"]`).addEventListener("change", (e) => {

      const currValue = e.target || e.currentTarget
      
      const currentItems = arr.filter(item => (item.parent == currValue.value) || (item.parent == -1));

      if (currentItems.length <= 0) {
        alert(`Error on data for ${value} id: ${currValue.value}`)
      } else {
        const targetSelect = document.querySelector(`[name="network-filters-${target}"]`)
        targetSelect.setAttribute('disabled', 'disabled');
        targetSelect.innerHTML = '';
        currentItems.forEach(element => {
          console.log(element)
          targetSelect.innerHTML = targetSelect.innerHTML + `<option value="${element.term_id}">${element.name}</option>`;
          targetSelect.removeAttribute('disabled');
        });
        clearArr.forEach(element => this.clearSelect(element))
      }

    })

  }

  clearSelect(value) {
    const targetSelect = document.querySelector(`[name="network-filters-${value}"]`)
    targetSelect.setAttribute('disabled', 'disabled');
  }

  selectOnChangeInit() {
    
    this.selectOnChange('continents', window.networkFiltersCountries, 'countries', ['cities']);
    this.selectOnChange('countries', window.networkFiltersCities, 'cities');


    document.querySelector(`[name="network-filters-cities"]`).addEventListener("change", (e) => {
      const currValue = e.target || e.currentTarget

      this.setState(({ loading }) => ({
        loading: true,
      }));

      const source = window.mapSource ||  `https://mipa2021.wearetesting.it/wp-json/wp/v2/_cty_network`;

      fetch(`${source}?_cta_location=${currValue.value}`)
        .then((response) => response.json())
        .then((data) => {
          this.setState(({ items, loading }) => ({
            items: data,
            loading: false
          }));
        });
      // fetch(`/stores&lang=it&city=${currValue.value}`)
      //   .then((response) => response.json())
      //   .then((data) => console.log(data));
    })


  }
 
  mounted() {
    this.selectOnChangeInit();
  }
 
  beforeDestroy() {
    
  }

}